import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Financial
 *
 */

const Financial = lazyLoad(
  () => import('app/modules/Financial'),
  (module) => module.default,
);

export default Financial;
